//#region Libraries
import { useState } from "react";
//#endregion
//#region Services
import {
	requestGetLocations,
	requestGetAllCampusDetail,
	requestGetInscriptionEventTypes,
	requestGetAllCampus,
	requestGetPayGrades,
} from "services/general";
import {
	requestGetAcadReinforceTypes,
	requestGetEnvironmentTypeList,
} from "services/acadReinforce/relatedToAcadReinforce";
//#endregion

const useDataRelatedToForm = ({
	loadingRequest,
	setLoadedDataRelatedToAcadReinforceForm,
}) => {
	//#region State
	const [acadReinforceTypes, setAcadReinforceTypes] = useState([]);
	const [locations, setLocations] = useState([]);
	const [inscriptionTypes, setInscriptionTypes] = useState([]);
	const [allCampus, setAllCampus] = useState([]);
	const [allCampusDetail, setAllCampusDetail] = useState([]);
	const [environmentTypeList, setEnvironmentTypeList] = useState([]);
	const [payGradeList, setPayGradeList] = useState([]);
	//#endregion
	//#region Functions
	// requestGetEnvironmentTypeList
	const fetchData = async () => {
		loadingRequest.show();
		await Promise.all([
			fillAcadReinforceTypes(),
			fillLocations(),
			fillAllCampus(),
			fillAllCampusDetail(),
			fillInscriptionTypes(),
			fillEnvironmentTypeList(),
			fillPayGradeList(),
		]);
		setLoadedDataRelatedToAcadReinforceForm(true);
		loadingRequest.hide();
	};
	const fillAcadReinforceTypes = async () => {
		const fetchAcadReinforceTypes = await requestGetAcadReinforceTypes();
		setAcadReinforceTypes(fetchAcadReinforceTypes);
	};
	const fillLocations = async () => {
		const fetchLocations = await requestGetLocations();
		setLocations(fetchLocations);
	};
	const fillInscriptionTypes = async () => {
		const fetchInscriptionTypes = await requestGetInscriptionEventTypes();
		setInscriptionTypes(fetchInscriptionTypes);
	};
	const fillAllCampus = async () => {
		const fetchAllCampusDetail = await requestGetAllCampus();
		setAllCampus(fetchAllCampusDetail);
	};
	const fillAllCampusDetail = async () => {
		const fetchAllCampusDetail = await requestGetAllCampusDetail();
		setAllCampusDetail(fetchAllCampusDetail);
	};
	const fillEnvironmentTypeList = async () => {
		const data = await requestGetEnvironmentTypeList();
		setEnvironmentTypeList(data);
	};
	const fillPayGradeList = async () => {
		const data = await requestGetPayGrades();
		setPayGradeList(data);
	};
	//#endregion
	return {
		fetchData,
		dataRelatedToForm: {
			acadReinforceTypes,
			locations,
			inscriptionTypes,
			allCampus,
			allCampusDetail,
			environmentTypeList,
			payGradeList,
		},
	};
};

export default useDataRelatedToForm;
